<template>
    <GroupedSelectionDialog
        :value="value"
        :groups="groups"
        :selection="selection"
        title="Опыт в отрасли"
        search-label="Поиск отрасли"
        empty-label="Отрасли не найдены"
        close-label="Закрыть выбор отраслей"
        id-prefix="industry"
        @input="$emit('input', $event)"
        @save="$emit('save', $event)"
    />
</template>

<script>
import GroupedSelectionDialog from './GroupedSelectionDialog.vue'

export default {
    name: 'IndustryDialog',
    components: { GroupedSelectionDialog },
    props: {
        value: Boolean,
        items: { type: Array, default: () => [] },
        selection: { type: Array, default: () => [] },
    },
    computed: {
        groups () {
            const groups = this.items.filter(item => !item.id.includes('.')).map(item => ({
                id: item.id,
                name: item.name.trim(),
                children: [],
            }))
            const indexed = new Map(groups.map(group => [group.id, group]))
            this.items.filter(item => item.id.includes('.')).forEach(item => {
                const parent = indexed.get(item.id.split('.')[0])
                if (parent) parent.children.push({ id: item.id, name: item.name.trim() })
            })
            groups.forEach(group => group.children.sort((a, b) => a.name.localeCompare(b.name, 'ru')))
            return groups.sort((a, b) => a.name.localeCompare(b.name, 'ru'))
        },
    },
}
</script>
